module.exports = __webpack_public_path__ + "img/trampoline.79b9ed90.jpg";